import React from 'react';
import { Focusable } from '..';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
import { Text } from '../Text';
import { Logo } from './components';
export function OauthButton({ onPress, type, style }) {
    const styles = useStyleSheet(getStyles);
    const title = type === 'apple' ? 'Apple' : type === 'fb' ? 'Facebook' : 'Google';
    return (React.createElement(Focusable, { style: [styles.container, style], hoverStyle: styles.hover, onPress: onPress },
        React.createElement(Logo, { type: type }),
        React.createElement(Text, { type: 'body', size: 'lg', weight: 'semibold', style: styles.text }, title)));
}
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        backgroundColor: color.invert2.p4,
        padding: size.F,
        paddingRight: size.I,
        borderRadius: size.M,
        flexDirection: 'row',
        alignItems: 'center'
    },
    hover: {
        backgroundColor: color.invert2.p10
    },
    text: { marginLeft: size.B }
}));
//# sourceMappingURL=index.js.map